import { getApiOrigin } from '../config/environment';

/** URL absolue d'un logo partenaire (chemins API relatifs → origine Symfony). */
export function resolveProviderLogoUrl(
  logoUrl?: string | null,
  logo?: string | null
): string {
  const raw = (logoUrl || (logo ? `/uploads/logos/${logo}` : '')).trim();
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  const origin = getApiOrigin();
  return `${origin}${raw.startsWith('/') ? raw : `/${raw}`}`;
}
